import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Table, SwitchButton, Status} from "components";
import {spServiceSettingsAction} from "redux/actions";
import {useLocation} from "react-router-dom";
import {subCategoriesAction} from "redux/actions";

const Address = () => {
    // Routers
    const location = useLocation();
    const id = location.pathname.split("/", 4)[3];

    // States
    const [tableRows, setTableRows] = useState();

    // Filter States
    const [status, setStatus] = useState();
    const [filterState, setfilterState] = useState();
    //const [catID, setcatID] = useState();

    // Redux actions
    const dispatch = useDispatch();
    const spServiceSettings = useSelector(state => state.spServiceSettings);
    const categories = useSelector(state => state.categories);
    const subcategories = useSelector(state => state.subCategories);

    useEffect(() => {
        dispatch(spServiceSettingsAction.get(id));
        return () => dispatch(spServiceSettingsAction.reset());
    }, []);

    useEffect(() => {
        if (!spServiceSettings?.length) {
            setTableRows();
            return;
        }

        let filtered = spServiceSettings;

        const catgid = filtered?.length > 0 ? filtered[0]?.CategoryID :0;

        dispatch(subCategoriesAction.get(catgid));
        

        // filter based on Status
        filtered = filtered?.filter(item =>
            status === "Enabled"
                ? item.enabled
                : status === "Disabled"
                    ? !item.enabled
                    : item
        );
        
        // Map table rows
        const data = filtered?.map(obj => ({
            ID: obj.ID,
            SpID: obj.SpID,
            CategoryID: categories?.find(item => item.id == obj.CategoryID)?.name,
            SubcategoryID: subcategories?.find(item => item.id == obj.SubcategoryID)?.name,

            S2C: <Status active={obj.S2C}/>,
            C2S: <Status active={obj.C2S}/>,
            S2VC: <Status active={obj.S2VC}/>,
            S2C2C: <Status active={obj.S2C2C}/>,
            Enabled: (
                <SwitchButton
                    enabled={obj.Enabled}
                    onClick={() => dispatch(spServiceSettingsAction.toggle(id, obj.ID))}
                />
            ),

            CreatedAt: `${new Date(obj.CreatedAt).toLocaleString()}`,
            UpdatedAt: `${new Date(obj.UpdatedAt).toLocaleString()}`
        }));

        setTableRows(data);
        
    }, [spServiceSettings, status, filterState]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "ID"
            },
            {
                title: "Provider"
            },
            {
                title: "Category"
            },
            {
                title: "Sub Category"
            },
            {
                title: "S2C"
            },
            {
                title: "C2S"
            },
            {
                title: "S2VC"
            },
            {
                title: "S2C2C"
            },
            {
                title: "Enabled"
            },
            {
                title: "Created"
            },
            {
                title: "Updated"
            }
        ],
        [tableRows]
    );

    return <Table headers={tableHeaders} data={tableRows}/>;
};

export default Address;
